<template>
  <div class="cic-page">
    <div class="cic-header">
      <h1 class="cic-title">Add channel</h1>
      <p class="cic-sub">Connect a new social channel to your profile.</p>
    </div>

    <connect-influencer-channel-container
      @continue="finished()"
    ></connect-influencer-channel-container>
  </div>
</template>

<script>
import ConnectInfluencerChannelContainer from "../containers/ConnectInfluencerChannelContainer";
export default {
  components: {
    ConnectInfluencerChannelContainer
  },
  methods: {
    finished() {
      this.$router.push({ name: "channels" });
    }
  }
};
</script>

<style scoped>
.cic-page {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 24px 20px 40px;
}
.cic-header { margin-bottom: 20px; }
.cic-title { font-size: 22px; font-weight: 650; color: var(--ink); margin: 0 0 2px; letter-spacing: -.02em; }
.cic-sub { font-size: 13.5px; color: var(--ink-3); margin: 0; }
</style>